import { object, string } from 'yup';

import { RoleEnum } from '@enum/role.enum';
import { getFormValidator } from '@util/form/get-form-validator';

export const accountInviteFormValidation = getFormValidator(
  object().shape({
    name: string().required(),
    email: string().email().required(),
    role: string().oneOf([RoleEnum.Admin, RoleEnum.Developer, RoleEnum.User]).required(),
  }),
);
